import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import CoolerImpoView from "./coolerImpoView";

function ValeCooler() {
  const [awb, setAwb] = useState("");
  const [currentView, setCurrentView] = useState("input");
  const [operacion, setOperacion] = useState("");
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    setAwb(e.target.value);
    setError("");
  };

  const handleSearch = () => {
    if (!awb.trim()) {
      setError("Este campo es obligatorio");
      return;
    }

    if (!operacion) {
      setError("Debes seleccionar una opción de operación");
      return;
    }

    // Validar formato tipo "139-39993671"
    const formatoGuia = /^\d{3}-\d{5,8}$/;

    if (!formatoGuia.test(awb)) {
      setError("El formato de la guía no es válido (ej. 139-39993671)");
      return;
    }

    setError("");

    // Redirigir a la vista correspondiente (sin cambiar URL)
    if (operacion === "impo") {
      setCurrentView("impo-view");
    } else if (operacion === "expo") {
      setCurrentView("expo-view");
    } else if (operacion === "transito") {
      setCurrentView("transito-view");
    }
  };

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>

      <ScrollToTop />

      <div className="container-fluid">
        {/* ======================== VISTA PRINCIPAL ======================== */}
        {currentView === "input" && (
          <>
            <div className="row justify-content-center">
              <div className="col-6">
                <label htmlFor="inputMaster" className="amc-label">
                  Master
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inputMaster"
                  onChange={handleInputChange}
                />
                {error && <div className="text-danger mt-2">{error}</div>}
              </div>

              <div className="col-6">
                <div className="d-flex gap-3 mt-4">
                  {["impo", "expo", "transito"].map((op) => (
                    <div className="form-check" key={op}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipoOperacion"
                        id={op}
                        value={op}
                        checked={operacion === op}
                        onChange={(e) => setOperacion(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor={op}>
                        {op.charAt(0).toUpperCase() + op.slice(1)}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="row justify-content-center mt-3">
              <div className="col-8 d-flex justify-content-end">
                <button className="btnn" onClick={handleSearch}>
                  Buscar
                </button>
              </div>
            </div>
          </>
        )}

        {/* ======================== VISTA IMPO ======================== */}
        {currentView === "impo-view" && (
          <CoolerImpoView awb={awb} operacion={operacion} onBack={() => setCurrentView("input")} />
        )}

        {/* ======================== PLACEHOLDERS (Expo/Transito) ======================== */}
        {currentView === "expo-view" && (
          <div className="text-center mt-5">
            <h3>Vista de Expo (próxima implementación)</h3>
            <button className="btnn mt-3" onClick={() => setCurrentView("input")}>
              Volver
            </button>
          </div>
        )}

        {currentView === "transito-view" && (
          <div className="text-center mt-5">
            <h3>Vista de Tránsito (próxima implementación)</h3>
            <button className="btnn mt-3" onClick={() => setCurrentView("input")}>
              Volver
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default ValeCooler;
